import { Box, BoxProps, Separator } from '@my/ui'
import { GroupCardCover, GroupCardCoverProps } from './group-card-cover'
import { GroupCardInfo, GroupCardInfoProps } from './group-card-info'
import { GroupCardControls, GroupCardControlsProps } from './group-card-controls'
import { GroupCardDescription } from './group-card-description'
import { GroupCardInfoExtra } from './group-card-info-extra'

export type GroupCardVerticalProps = {
  description?: string
  imagePriority?: boolean
} & GroupCardInfoProps &
  GroupCardControlsProps &
  GroupCardCoverProps

/**
 * Vertical group card for displaying group information.
 **/
export const GroupCardVertical = ({
  id,
  name,
  visibility,
  totalMembers,
  href,
  profileImage,
  coverImage,
  description,
  hasJoined,
  isAdmin,
  canJoin,
  canLeave,
  shareable,
  imagePriority,
  hasPendingRequest,
  ...props
}: GroupCardVerticalProps & BoxProps) => {
  return (
    <Box gap="$4" fd="column" {...props}>
      <GroupCardCover coverImage={coverImage} imagePriority={imagePriority} />
      <GroupCardInfo
        name={name}
        href={href}
        visibility={visibility}
        totalMembers={totalMembers}
        profileImage={profileImage}
        w="100%"
        titleProps={{
          numberOfLines: 3,
        }}
        infoWrapperProps={{
          fd: 'row',
        }}
      />

      <GroupCardInfoExtra
        infoWrapperProps={{
          justifyContent: 'flex-start',
          width: '100%',
        }}
        visibility={visibility}
        totalMembers={totalMembers}
      />
      <GroupCardControls
        w="100%"
        ai="center"
        fd="row-reverse"
        id={id}
        href={href}
        isAdmin={isAdmin}
        visibility={visibility}
        hasJoined={hasJoined}
        canJoin={canJoin}
        canLeave={canLeave}
        shareable={shareable}
        hasPendingRequest={hasPendingRequest}
        joinButtonProps={{
          flex: 1,
        }}
      />

      {description && description.length > 0 && (
        <>
          <Separator w="100%" bg="$overlay4" borderColor="$overlay4" />
          <GroupCardDescription description={description} />
        </>
      )}
    </Box>
  )
}
